import { useEffect, useState, useCallback } from 'react'
import { useAppSelector } from '../../../../../../redux/hooks'
import { getInstancesWithAdd, getInstancesWithAddglobal } from '../request/request'
import axios from 'axios'
import { utils, writeFile } from 'xlsx'
import { useAuth } from '../../../../auth'
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL

type MPLS = {
  inlabel: string
  type: string
  nexthop: string
  outlabel: string
}

export default function MPLS(props: any) {
  const { currentUser } = useAuth()

  const Id = useAppSelector((state) => state.SuscriptionSlice.id)
  const Type = useAppSelector((state) => state.CloudSlice.Type)
  const tenant = useAppSelector((state) => state.TenantSlice.id)
  const nameregion = useAppSelector((state) => state.RegionSlice.name)

  const [Instancia, setInstancia] = useState([{ id: 0, name: ' ', type: '' }])
  const [Busqueda, setBusqueda] = useState('')
  const [DataMPLS, setDataMPLS] = useState<MPLS[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          Id !== 0 &&
          Id !== -1 &&
          Type !== 'CloudGlobal' &&
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS')
        ) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(
              Id,
              'Ctx.Troubleshooting.MPLS',
              Type,
              nameregion
            )
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0]?.id ?? '')
            }
          } else {
            const instancias = await getInstancesWithAddglobal(
              Id,
              tenant,
              'Ctx.Troubleshooting.MPLS',
              Type,
              nameregion
            )
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0]?.id ?? '')
            }
          }
        } else if (
          Id !== 0 &&
          Id !== -1 &&
          Type === 'CloudGlobal' &&
          currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS')
        ) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.MPLS')
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0]?.id ?? '')
            }
          } else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.MPLS')
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0]?.id ?? '')
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error)
      }
    }

    fetchData()
  }, [nameregion, Id, Type, tenant, currentUser])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS')) {
          if (tenant === 0) {
            const instancias = await getInstancesWithAdd(Id, 'Ctx.Troubleshooting.MPLS')
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0]?.id ?? '')
            }
          } else {
            const instancias = await getInstancesWithAddglobal(Id, tenant, 'Ctx.Troubleshooting.MPLS')
            if (instancias.data && instancias.data.error === 'id suscription invalido') {
              setInstancia([])
            } else {
              setInstancia(instancias.data)
              setBusqueda(instancias.data[0]?.id ?? '')
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error)
      }
    }

    fetchData()
  }, [Id, currentUser, tenant])

  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    if (props.tab === 4) {
      try {
        if (Busqueda === '') {
          Swal.fire('Oooops!', 'Please select an Instance', 'warning')
          return
        }

        let type = ''
        for (const x of Instancia) {
          if (Number(Busqueda) === x.id) {
            type = x.type
          }
        }

        const body = { type }
        if (tenant === 0) {
          const res = await axios.post(API_URL + '/v1/troubleshooting/instances/mpls/' + Busqueda, body)
          if (res.data && res.data.error) {
            // Por si la respuesta es un objeto con {error: "..."}
            Swal.fire('Error', res.data.error, 'error')
            setDataMPLS([])
          } else if (Array.isArray(res.data)) {
            setDataMPLS(res.data)
          } else {
            // Si no es array y no tiene error
            setDataMPLS([])
          }
        } else {
          const res = await axios.post(
            API_URL + '/v1/troubleshooting/instances/mpls/' + Busqueda + '?tenantId=' + tenant,
            body
          )
          if (res.data && res.data.error) {
            Swal.fire('Error', res.data.error, 'error')
            setDataMPLS([])
          } else if (Array.isArray(res.data)) {
            setDataMPLS(res.data)
          } else {
            setDataMPLS([])
          }
        }
      } catch (error: any) {
        console.log(error)
      }
    }
  }

  useEffect(() => {
    if (Type) {
      setDataMPLS([])
    }
    if (tenant) {
      setDataMPLS([])
    }
  }, [Type, tenant])

  const exportFile = useCallback(() => {
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
    const day = currentDate.getDate().toString().padStart(2, '0')
    const formattedDate = `${year}-${month}-${day}`

    // Verificamos que DataMPLS sea un array
    const data = Array.isArray(DataMPLS) ? DataMPLS : []

    const ws = utils.json_to_sheet(data)
    const wb = utils.book_new()
    utils.book_append_sheet(wb, ws, 'MPLS Table')
    utils.sheet_add_aoa(ws, [['Inbound Label', 'Type', 'Nexthop', 'Outbund Label']], { origin: 'A1' })

    let nombre = 'Unknown'
    for (const x of Instancia) {
      if (Number(Busqueda) === x.id) {
        nombre = x.name
      }
    }
    writeFile(wb, nombre + '_MPLS_' + formattedDate + '.xlsx')
  }, [DataMPLS, Busqueda, Instancia])

  return (
    <>
      <div style={{ marginTop: '15px' }} className="f-titulo fs-md mb-3 text-marino text-center ">
        MPLS Table
      </div>
      <div
        className="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid"
        id="kt_create_account_stepper"
      >
        <div
          className="card d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px w-xxl-400px me-9 border border-gray-300"
          style={{ marginBottom: '20px' }}
        >
          <div className="card-body px-6 px-lg-10 px-xxl-15 py-20">
            <div className="stepper-nav">
              <div className="stepper-item current" data-kt-stepper-element="nav">
                <div className="stepper-wrapper">
                  <div className="stepper-label">
                    <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
                      <div className="d-flex flex-column flex-row-auto">
                        <label className="form-label f-bold fs-p text-marino required form-label">
                          Instance
                        </label>
                        <select
                          className="custom-select w-200px"
                          aria-label="Select example"
                          onChange={cambiarstate}
                          value={Busqueda}
                        >
                          {Instancia.length === 0 && <option hidden>No data</option>}
                          <option hidden>Select an Instance </option>
                          {Id !== 0 &&
                            Instancia.map((ins: any, i) => (
                              <option key={i} value={ins.id}>
                                {ins.name}
                              </option>
                            ))}
                          {Id === 0 &&
                            Type === 'Global' &&
                            Instancia.map((ins: any, i) => (
                              <option key={i} value={ins.id}>
                                {ins.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="w-30px"></div>
                      <br />
                      <br />

                      <div className="d-flex flex-column flex-row-auto">
                        <br />
                        <button type="submit" className="btn-light-marino" onClick={handleSubmit}>
                          <span className="indicator-label">Search</span>
                        </button>
                      </div>

                      <div className="w-30px"></div>

                      <div className="text-center">
                        <br />
                        <button className="btn-light-marino" onClick={exportFile}>
                          <i className="bi bi-download"></i>Export Excel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="black-background d-flex flex-row-fluid bg-body rounded border"
          style={{ marginBottom: '20px' }}
        >
          <div className="w-100">
            <div className="pb-10 pb-lg-15">
              <div className="card-body card-scroll h-300px">
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead className="table-header-light bg-marino">
                    <tr>
                      <th className="table-cell">Inbound Label</th>
                      <th className="table-cell">Type</th>
                      <th className="table-cell">Nexthop</th>
                      <th className="table-cell">Outbund Label</th>
                    </tr>
                  </thead>
                  <tbody style={{ marginTop: '0px' }}>
                    {Array.isArray(DataMPLS) &&
                      DataMPLS.length !== 0 &&
                      DataMPLS.map((d, i) => (
                        <tr key={i} className="table-row">
                          <td className="table-cell">{d.inlabel}</td>
                          <td className="table-cell">{d.type}</td>
                          <td className="table-cell">{d.nexthop}</td>
                          <td className="table-cell">{d.outlabel}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {Id === -1 && Type !== 'CloudGlobal' && (
                <table className="table table-striped gy-7 gs-7">
                  <tbody>
                    <div className="text-center">Select a Cloud with available subscriptions</div>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
